export default __webpack_public_path__ + "6c6422b702090993ffc2e8f2e1c82656.png";